import React from 'react';
import { Legals } from '@luckycart/xpn-types';

import { Button, StyledButtonSpan } from '../common-screen-display/common/common.style';

import { AccessibilityLink, ButtonsWrapper, ImgIconsLegal } from './Bottom.links.style';
import legalIcon from './images/legal.icon.svg';

export type BottomLinksProps = { legals: Legals | undefined; siteKey?: string };

const CARREFOUR_SITE_KEY = 'y4hnl2U6';
const ACCESSIBILITY_DECLARATION_URL = 'https://assets.luckycart.com/accessibility/declaration-accessibilite-paiement.html';

const BottomLinks: React.FunctionComponent<BottomLinksProps> = (props: BottomLinksProps) => {
  return (
    <ButtonsWrapper>
      {props.legals?.activ === 'block' && (
        <Button as="a" href={props.legals?.buttonUrl} target="_blank">
          <ImgIconsLegal src={legalIcon} />
          <StyledButtonSpan>{props.legals?.buttonText}</StyledButtonSpan>
        </Button>
      )}
      {props.siteKey === CARREFOUR_SITE_KEY && (
        <AccessibilityLink href={ACCESSIBILITY_DECLARATION_URL} target="_blank">
          Accessibilité : non-conforme
        </AccessibilityLink>
      )}
    </ButtonsWrapper>
  );
};

export default BottomLinks;
